<div class="superuser-background">
  <nav class="navbar navbar-expand-sm bg-dark navbar-dark">
    <div class="environment">
      {{uiContext ? uiContext.name: ''}}
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav">

        <li class="nav-item">
          <a class="nav-link" routerLink="./tenants">Tenants</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./users">Users</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./tools">Tools</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./rightgroups">Right Groups</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./userrights">User rights</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./additionalrights">Additional rights</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./grouprights">Group rights</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./automationmappings">Automation mappings</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./regovivomappings">Rego-Vivo mappings</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="./about">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="originRoute || '../home'">Back to map</a>
        </li>
        <!-- <li class="nav-item">
          <button type="button" class="btn btn-info btn-md" (click)="logout()">
              <span class="glyphicon glyphicon-log-out"></span> Log out
          </button>
        </li> -->
      </ul>
    </div>
  </nav>

  <div class="container" style="margin:0.1em">
    <router-outlet></router-outlet>
    <app-messages></app-messages>
  </div>

</div>
